import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-init-mobile-emai',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './init-mobile-emai.component.html',
  styleUrl: './init-mobile-emai.component.scss'
})
export class InitMobileEmaiComponent {
  isDisabled: boolean = false;
  @Input() EmpMasterID: number = 0;
  @Input() IsDraft: boolean = true;
  PreonboardinSetupDetail = {
    EmpMasterId: 0,
    EmployeeName: null,
    URLValidity: null,
    EmpServiceTypeId: null,
    ServiceTypeName: null,
    BranchID: null,
    BranchName: null,
    ClientId: null as any,
    ClientName: null,
    SiteId: null as any,
    SiteName: null,
    DesignationId: null as any,
    DesignationName: null,
    //DutyID: null, //
    JoiningDate: null as any,
    ProbationDate: null as any,
    FirstApproverId: null,
    FirstApproverName: null,
    SecondApproverId: null,
    SecondApproverName: null,
    EmpType: '',
    Email: null,
    MobileNo: null,
    EmpCode: null,
    SelectType: 'I',
    IsDraft: true,
  }

  constructor(
    private toast: ToastService,
    private activeModal: NgbActiveModal,
    private employeeRegistration: EmployeeRegistrationService,
    private modalService: NgbModal,
    protected common:CommonService
  ) { }

  ngOnInit(): void {
    if (this.EmpMasterID > 0) {
      this.GetData('PreOnBoarding');
    }
  }

  Verification(form: any) {
    if (form.valid) {
      this.isDisabled = true;
      this.SaveEmpPreOnBoarding();
    } else {
      form.submitted = true;
    }
  }

  GetData(TabName: string) {
    this.isDisabled = true;
    this.employeeRegistration.EmpRegSelectGetData({ 'SelectType': TabName, 'EmpMasterId': this.EmpMasterID, 'IsDraft': this.IsDraft}).subscribe({
      next: (response) => {
        if (response.Table.toString() != '') {
          this.PreonboardinSetupDetail = response.Table[0];
        }
        this.PreonboardinSetupDetail.IsDraft = true;
        this.PreonboardinSetupDetail.SelectType = 'I';
        this.isDisabled = false;
      },
      complete: () => {},
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SaveEmpPreOnBoarding(){
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want update?';
    modalRef.result.then((result: any) => {
      if (result) {
        this.employeeRegistration.SaveEmpPreOnBoarding(this.PreonboardinSetupDetail).subscribe({
          next: (response) => {
            if (response.Error_Code == '01') {
              this.activeModal.close({Email: this.PreonboardinSetupDetail.Email, MobileNo: this.PreonboardinSetupDetail.MobileNo,});
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
            } else {
              //this.SendPreOnBoardingLink();
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              this.isDisabled = false;
            }
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  close() {
    this.activeModal.close();
  }
}
